// order.component.ts

import {Component, OnChanges, OnInit} from '@angular/core';
import {OrderService} from '../../services/order.service';
import {FormGroup, FormBuilder, Validators} from '@angular/forms';

import {FormField, FieldOption} from '../../interfaces/form';
import {MenuItem} from '../../interfaces/menu-item';

import {FormService} from '../../services/form.service';
import {Order} from '../../interfaces/order';

import {ActivatedRoute, Router} from '@angular/router';
import {MenuItemsService} from '../../services/menu-items.service';
import {OrderState} from '../../services/OrderState';
import {v4 as uuid} from 'uuid';

import {IMyDpOptions} from 'mydatepicker';
import {ItonicsAuthService} from '../../services/itonicsAuth.service';
import {UserService} from '../../services/user.service';
import * as moment from 'moment-timezone';


@Component({
  selector: 'app-create',
  templateUrl: './order.component.html',
  styleUrls: ['./order.component.scss']
})
export class OrderComponent implements OnInit, OnChanges {
  searchResult = [];
  userDatalist: any = [];

  public selectedItem: MenuItem = {id: 0, title: '', price: 0};
  public loggedInGrp = [];
  now = new Date();
  public currentTime = moment.tz(this.now, 'Asia/Kathmandu').format('HH:mm:ss');
  timeRightNow = moment(this.currentTime, 'h:mma');
  endTime = moment('11:30am', 'h:mma');
  public canEdit = this.timeRightNow.isBefore(this.endTime);
  public myDatePickerOptions: IMyDpOptions = {
    // other options...
    dateFormat: 'yyyy-mm-dd',
    openSelectorOnInputClick: true
  };

  angForm: FormGroup;
  fields: Array<FormField>;
  id: number;
  menuItemId: number;
  formSubmitted: boolean;
  orderName: string;
  isFormReady = false;
  public isError = false;
  public isLessThan = false;
  isAdmin = false;

  constructor(
    private orderservice: OrderService,
    private menuService: MenuItemsService,
    private fb: FormBuilder,
    private fs: FormService,
    private router: Router,
    private route: ActivatedRoute,
    private itonicsAuthService: ItonicsAuthService,
    private uservice: UserService
  ) {
    this.itonicsAuthService.getCurrentUserGrp().subscribe(
      (userGrp) => {
        this.loggedInGrp = userGrp;
        if (this.loggedInGrp.find((_grp) => _grp === 'Administrator')) {
          this.isAdmin = true;
        }
      },
      (err) => {
        console.log(err);
      }
    );

    this.uservice.getUserList().subscribe((data) => {
      this.userDatalist = data;
    });
  }

  createForm(order?: Order) {
    this.fields = [
      <FormField>{
        label: 'isNew',
        type: 'number',
        name: 'isNew',
        value: order && order.id ? 0 : 1,
        hidden: true
      },
      <FormField>{
        label: 'id',
        type: 'number',
        name: 'id',
        value: order && order.id ? order.id : uuid(),
        hidden: true
      },
      <FormField>{
        label: 'Item Name ',
        type: 'autocomplete',
        name: 'menuItemId',
        value: {id: this.selectedItem.id, title: this.selectedItem.title, price: this.selectedItem.price},
        validation: {required: true},
        searchResult: ''
      },
      /*       <FormField>{
                 label: 'menuItemId',
                 type: 'number',
                 name: 'menuItemId',
                 value: this.menuItemId.toString(),
                 hidden: true
             },*/
      <FormField>{
        label: 'Packing',
        name: 'packing',
        type: 'checkbox',
        value: order && order.packing ? order.packing : false
      },
      <FormField>{
        label: 'Quantity',
        type: 'number',
        name: 'quantity',
        value: order && order.quantity ? order.quantity : 1,
        validation: {
          required: true
        }
      },
      {
        label: 'Note',
        type: 'textarea',
        name: 'note',
        value: order && order.note ? order.note : ''
      }
    ];

    if (this.isAdmin) {
      this.fields.push(<FormField>{
        label: 'User',
        type: 'select',
        name: 'userId',
        value: order && order.userId ? order.userId : 0,
        option: this.userDatalist
      });

      this.fields.push(<FormField>{
        label: 'Date',
        type: 'dateSelect',
        name: 'date',
        value: order && order.date ? order.date : 0
      });

    }
    this.fs.getFormGroup(this.fields).subscribe((fg) => {
      this.angForm = fg;
    });
  }

  addOrder(formValid, formValues: any) {
    if (formValid) {
      this.formSubmitted = true;
      formValues.menuItemId = formValues.menuItemId.id;

      console.log(formValues.menuItemId);

      if (formValues.quantity < 0.5) {
        this.isLessThan = true;
      } else {
        if (formValues.menuItemId) {
          this.orderservice.arrangeOrder(formValues, true);
          // this.createForm();
          this.isLessThan = false;
          this.isError = false;
        } else {
          this.isError = true;
        }
      }
      this.triggerSearch();
    }
  }

  onCancel() {
    // this.isError = false;
    // this.createForm();
    this.router.navigate(['home/add-order']).then((e) => {
      if (e) {
        console.log('Navigation is successful!');
      } else {
        console.log('Navigation has failed!');
      }
    });
  }

  ngOnChanges() {
    console.log('trigger');
  }

  triggerSearch() {
    this.route.params.subscribe((params) => {
      if (params.id) {
        this.menuItemId = params.id;

        if (params.orderId) {
          this.id = params.orderId;

          this.orderservice.getOrderInfobyId(params.orderId).subscribe((order) => {
            this.selectedItem = {
              id: order['menuItem']['id'],
              title: order['menuItem']['title'],
              price: order['menuItem']['price']
            };

            this.createForm(order);
            this.isFormReady = true;

            this.angForm.controls['menuItemId'].valueChanges.subscribe((data) => {
              this.menuService.search_item(data).subscribe((response) => {
                this.fields[2]['searchResult'] = response;
              });
            });
          });
        } else {
          this.menuService.getMenuById(this.menuItemId).subscribe((res) => {
            this.selectedItem = {
              id: res.id,
              title: res.title,
              price: res.price
            };

            this.createForm();
            this.isFormReady = true;

            this.angForm.controls['menuItemId'].valueChanges.subscribe((data) => {
              this.menuService.search_item(data).subscribe((response) => {
                this.fields[2]['searchResult'] = response;
              });
            });
          });
        }
      } else {
        this.createForm();
        this.isFormReady = true;
      }
    });
    if (this.isFormReady) {
      this.angForm.controls['menuItemId'].valueChanges.subscribe((data) => {
        this.menuService.search_item(data).subscribe((response) => {
          this.fields[2]['searchResult'] = response;
          console.log(this.fields);
        });
      });
    }
  }

  ngOnInit() {
    this.triggerSearch();
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/order/order.component.ts